import React, { useEffect, useRef } from 'react';

import { range } from 'lodash';
import styles from './Skeleton.module.scss';

interface ISkeletonProps {
  height?: number;
  width?: number;
  radius?: number;
  type?: 'circle' | 'container' | 'text';
  rows?: number;
  shimmer?: boolean;
  className?: string;
  asSpan?: boolean;
}

function formatToStyle(value: number | undefined): string {
  return value ? `${value}px` : '100%';
}

const Skeleton = ({
  height,
  width,
  radius = 0,
  type = 'container',
  rows = 0,
  shimmer = true,
  className,
  asSpan = false,
}: ISkeletonProps) => {
  const skeletonRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (skeletonRef && skeletonRef.current) {
      skeletonRef.current.style.height = formatToStyle(height);
      skeletonRef.current.style.width = formatToStyle(width);

      if (type === 'circle') {
        skeletonRef.current.style.borderRadius = '50%';
      } else {
        skeletonRef.current.style.borderRadius = `${radius}px`;
      }
    }
    return () => { skeletonRef.current = null; };
  }, []);

  if (type === 'text') {
    return (
      <ul
        className={
    `${styles.TextContainer}${className ? ` ${className}` : ''}`
  }
        data-test="skeleton-text"
      >
        {
      range(rows).map((row) => (
        <li
          key={row}
          style={{
            height,
            width,
            borderRadius: radius
          }}
          className={`${styles.Skeleton}${shimmer ? ` ${styles.Shimmer}` : ''}`}
        />
      ))
    }
      </ul>
    );
  }

  if (asSpan) {
    return (
      <span
        ref={skeletonRef}
        data-test="skeleton"
        className={`${styles.Skeleton}${shimmer ? ` ${styles.Shimmer}` : ''}${className ? ` ${className}` : ''}`}
      />
    );
  }

  return (
    <div
      ref={skeletonRef}
      data-test="skeleton"
      className={`${styles.Skeleton}${shimmer ? ` ${styles.Shimmer}` : ''}${className ? ` ${className}` : ''}`}
    />
  );
};

export default Skeleton;
